/* eslint-disable */
import React, { useState, useEffect } from 'react';
import styles from './financials.module.scss';
import BackButton from '../../../../Assets/images/svg/black_back_button.svg';
import { useNavigate } from 'react-router-dom';
import TravelCost from './TravelCost/travelCost';
import SoftwareAndHardwareCost from './SoftwareAndHarwareCost/softwareAndHardwareCost';
import StaffingCost from './StaffingCost/staffingCost';
import CloudCost from './CloudCost/cloudCost';
import Skillset from './Skillset/skillset';

import Summary from './Summary/summary';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

const Financials = () => {
  const navigate = useNavigate();
  const [effortValue, setEffortValue] = useState('Required Skillset');
  const [isMobileView, setIsMobileView] = useState(false);
  useEffect(() => {
    checkMobileView();
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (event, newValue) => {
    setEffortValue(newValue);
  };

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1100);
  };

  const effortsDisplay = () => {
    switch (effortValue) {
      case 'Required Skillset':
        return <Skillset />;
      case 'Staffing Cost':
        return <StaffingCost />;
      case 'Software and Hardware Cost':
        return <SoftwareAndHardwareCost />;
      case 'Cloud Cost':
        return <CloudCost />;
      case 'Travel Cost':
        return <TravelCost />;
      case 'Summary':
        return <Summary />;
      default:
        return <StaffingCost />;
    }
  };

  return (
    <div className={styles['financials-container']}>
      <div className={styles['financials-main-text']}>
        <button
          type="button"
          className={styles['efforts-back-button']}
          onClick={() => navigate(-1)}
        >
          <img src={BackButton} alt="back icon" />
        </button>{' '}
        Deal Finance (Cost)
      </div>
      <Box className={styles['efforts-tabs']}>
        <Tabs
          value={effortValue}
          textColor={'#6B5CE8'}
          indicatorColor={'#6B5CE8'}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#6B5CE8',
            },
            '& .Mui-selected': {
              color: '#6B5CE8 !important',
            },
          }}
          aria-label="wrapped label tabs example"
        >
          <Tab
            value="Required Skillset"
            label="Required Skillset"
            sx={{
              minWidth: !isMobileView ? 200 : 'auto',
              textTransform: 'none',
              fontSize: !isMobileView ? 16 : 14,
              fontWeight: effortValue === 'Staffing Cost' ? '600' : '400',
            }}
          />
          <Tab
            value="Staffing Cost"
            label="Staffing Cost"
            sx={{
              minWidth: !isMobileView ? 200 : 'auto',
              textTransform: 'none',
              fontSize: !isMobileView ? 16 : 14,
              fontWeight: effortValue === 'Staffing Cost' ? '600' : '400',
            }}
          />

          <Tab
            value="Cloud Cost"
            label="Cloud Cost"
            sx={{
              minWidth: !isMobileView ? 200 : 'auto',
              textTransform: 'none',
              fontSize: !isMobileView ? 16 : 14,
              fontWeight: effortValue === 'Cloud Cost' ? '600' : '400',
            }}
          />
          <Tab
            value="Software and Hardware Cost"
            label="Software and Hardware Cost"
            sx={{
              minWidth: !isMobileView ? 200 : 'auto',
              textTransform: 'none',
              fontSize: !isMobileView ? 16 : 14,
              fontWeight:
                effortValue === 'Software and Hardware Cost' ? '600' : '400',
            }}
          />
          <Tab
            value="Travel Cost"
            label="Travel Cost"
            sx={{
              minWidth: !isMobileView ? 200 : 'auto',
              textTransform: 'none',
              fontSize: !isMobileView ? 16 : 14,
              fontWeight: effortValue === 'Travel Cost' ? '600' : '400',
            }}
          />
          <Tab
            value="Summary"
            label="Summary"
            sx={{
              minWidth: !isMobileView ? 200 : 'auto',
              textTransform: 'none',
              fontSize: !isMobileView ? 16 : 14,
              fontWeight: effortValue === 'Summary' ? '600' : '400',
            }}
          />
        </Tabs>
      </Box>
      {effortsDisplay()}
    </div>
  );
};

export default Financials;
